export default "__VITE_ASSET__D9G5x8mt__"